import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/login/page.tsx");
